import { create } from 'zustand';
import type { Side } from '@/common/constants';
import { useDialogStore } from '@/components/dialogs/dialogStore';
import type { ViewPosition } from '../position/types';
import type { TpSlFormSchema } from './schema';

interface TpSlModalData {
  baseCurrency: string;
  size: number;
  side: Side;
  entryPrice: number;
  markPrice: number;
  leverage: number;
  assetDecimals: number;
  quoteDecimals: number;
  takeProfit?: number;
  stopLoss?: number;
  takeProfitLimitPrice?: number;
  stopLossLimitPrice?: number;
  tpSlPercentage?: number;
  onSubmit: (data: TpSlFormSchema) => Promise<void>;
}

interface TpSlModalStore {
  data: TpSlModalData | null;
  setData: (data: TpSlModalData) => void;
  clearData: () => void;
}

export const useTpSlModalStore = create<TpSlModalStore>((set) => ({
  data: null,
  setData: (data) => set({ data }),
  clearData: () => set({ data: null }),
}));

export function openTpSlDialog(
  position: ViewPosition,
  onSave: (data: TpSlFormSchema, position: ViewPosition) => Promise<void>
): void {
  useTpSlModalStore.getState().setData({
    baseCurrency: position.assetCurrency,
    size: position.size,
    side: position.side,
    entryPrice: position.entryPrice,
    markPrice: position.markPrice,
    leverage: position.leverage,
    assetDecimals: position.assetDecimals,
    quoteDecimals: position.quoteDecimals,
    takeProfit: position.takeProfit,
    stopLoss: position.stopLoss,
    takeProfitLimitPrice: position.takeProfitLimitPrice,
    stopLossLimitPrice: position.stopLossLimitPrice,
    tpSlPercentage: position.tpSlPercentage,
    onSubmit: (data) => onSave(data, position),
  });
  useDialogStore.getState().openDialog('tpSlDialog');
}
